import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var WorkOrders = Class.create({
  	initialize: function() {
	},
	getWorkOrders: function(filterOption, sortOptions, callback) {
		var self = this;
		var url = "maintenance/workorders?filterOption=" + filterOption;
		if(sortOptions) {
			url += "&sortOptions=" + sortOptions;
		}
		var data = server.getData(url,null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if(callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e, "danger", "top", "center");
		});
	},
	getWorkOrdersWithBuildingId: function (buildingId, callback) {
		var self = this;
		var url = "maintenance/orders/" + buildingId;
		var data = server.getData(url,null,false);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if(callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e, "danger", "top", "center");
		});
	},
	getWorkOrderCount: function(priority, callback) {
		var url = "maintenance/workorders/count?priority=" + priority;
		var data = server.getData(url,null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if(callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
		});
	},
	getWorkOrdersForTenant: function(filterOption, sortOptions, callback) {
		var self = this;
		var url = "maintenance/tenant/workorders?filterOption=" + filterOption;
		if(sortOptions) {
			url += "&sortOptions=" + sortOptions;
		}
		var data = server.getData(url,null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if(callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e, "danger", "top", "center");
		});
	},
});

export let workOrders = new WorkOrders();


// WEBPACK FOOTER //
// app/core/controllers/WorkOrders.js